'use client'

import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const LiquidationDetailDataListLoading = () => {
  return (
    <DataList.Root>
      <DataList.Column>
        <InfoCardLoading />
        <InfoCardLoading />
      </DataList.Column>
      <DataList.Column>
        <InfoCardLoading />
        <InfoCardLoading />
      </DataList.Column>
    </DataList.Root>
  )
}

const InfoCardLoading = () => (
  <DataList.Line>
    <Skeleton className="h-md w-[100%] rounded-[20px]" />
  </DataList.Line>
)

export default memo(LiquidationDetailDataListLoading)
